const STATIC_PAGE_TITLES = new Map([
  ["/", "Home"],
  ["/products", "All Products"],
  ["/category", "Shop by Category"],
  ["/about", "About Us"],
  ["/about-us", "About Us"],
  ["/sell-on-apparify", "Sell on Apparify"],
  ["/contact-us", "Contact Us"],
  ["/help-center", "Help Center"],
  ["/careers", "Careers & Jobs"],
  ["/careers/my-applications", "My Job Applications"],
  ["/terms-and-conditions", "Terms & Conditions"],
  ["/privacy-policy", "Privacy Policy"],
  ["/shipping-information", "Shipping Information"],
  ["/returns-and-refunds", "Returns & Refunds"],
  ["/cart", "Your Cart"],
  ["/checkout", "Checkout"],
  ["/checkout/result", "Checkout Result"],
  ["/messages", "Messages"],
  ["/login", "Login"],
  ["/register", "Create Account"],
  ["/verify-email", "Verify Email"],
  ["/forgot", "Forgot Password"],
  ["/business/register", "Business Registration"],
  ["/account", "Account"],
  ["/account/profile", "Account Profile"],
  ["/account/addresses", "Addresses"],
  ["/account/change-password", "Change Password"],
  ["/account/privacy", "Privacy"],
  ["/account/notifications", "Notifications"],
  ["/account/notification-settings", "Notification Settings"],
  ["/account/applications", "Business Applications"],
  ["/account/business-onboarding", "Business Onboarding"],
  ["/account/wallet", "Wallet"],
  ["/account/purchase", "My Purchases"],
  ["/profile/edit", "Account Profile"],

  ["/business/login", "Business Login"],
  ["/supplier/login", "Supplier Login"],
  ["/supplier/register", "Supplier Registration"],
  ["/supplier/verify-email", "Verify Supplier Email"],
  ["/admin/login", "Admin Login"],
]);

function normalizePathname(pathname = "/") {
  if (pathname === "/") return pathname;
  return pathname.replace(/\/+$/, "") || "/";
}

function titleize(value = "") {
  return decodeURIComponent(value)
    .replace(/[-_]+/g, " ")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function getPageTitle(pathname) {
  const path = normalizePathname(pathname);
  const staticTitle = STATIC_PAGE_TITLES.get(path);
  if (staticTitle) return staticTitle;

  if (/^\/business\/resubmit\/[^/]+$/.test(path)) return "Resubmit Business Application";
  if (path === "/business" || path.startsWith("/business/")) return "Business";
  if (path === "/supplier" || path.startsWith("/supplier/")) return "Supplier";
  if (path === "/admin" || path.startsWith("/admin/")) return "Admin";

  if (/^\/product\/[^/]+$/.test(path)) return "Product Details";
  if (/^\/careers\/jobs\/[^/]+$/.test(path)) return "Position Details";
  if (/^\/careers\/action\/[^/]+$/.test(path)) return "Candidate Next Step";
  if (/^\/store\/[^/]+$/.test(path)) return "Store";
  if (/^\/order-confirmation\/[^/]+$/.test(path)) return "Order Confirmation";
  if (/^\/account\/purchase\/[^/]+\/tracking$/.test(path)) return "Order Tracking";
  if (/^\/account\/business-onboarding\/[^/]+$/.test(path)) return "Business Onboarding";

  const categoryMatch = path.match(/^\/category\/([^/]+)$/);
  if (categoryMatch) return titleize(categoryMatch[1]);

  return "Page Not Found";
}

export function formatDocumentTitle(pageTitle) {
  return pageTitle === "Home" ? "Apparify" : `${pageTitle} | Apparify`;
}
